import api_agents from '../api/agents'
import api_base from '../api/api'


// initial state
const state = {
  role: undefined,
  messages: [],
  list_state: 'loading',
  message_body: '',
};

// getters
// noinspection JSUnusedGlobalSymbols
const getters = {
  api: (state) => {
    if (state.role === 'agent') return api_agents;
    if (state.role === 'user') return api_base;
    return {};
  },
  allMessages: state => {
    return _.orderBy(state.messages, 'attributes.created_at')
  },
  unreadMessages: (state, getters) => {
    return _.filter(getters.allMessages, message => {return message.attributes.unread})
  },
};

// actions
// noinspection JSUnusedGlobalSymbols
const actions = {
  getMessages({dispatch, commit, getters}, payload) {
    console.log('ACTION - getMessages :', payload);
    commit('setListState', 'loading');
    return getters.api.getMessages(payload, data => {
      commit('setMessages', data.data);
      commit('setListState', 'stored');
    })
  },

  addMessage({dispatch, commit, getters}, payload) {
    console.log('ACTION - addMessage :', payload);
    getters.api.createMessage(payload, data => {
      commit('addMessage', data.data);
      commit('setMessageBody', '');
    });
  },

  readAllMessages({dispatch, commit, getters}, payload) {
    console.log('ACTION - readAllMessages :', payload);
    getters.api.readAllMessages(payload, data => {
      _.each(getters.unreadMessages, message => {
          commit('readMessage', message);
        }
      )
    })
  },
};

// mutations
// noinspection JSUnusedGlobalSymbols
const mutations = {
  setListRole(state, role){
    state.role = role;
  },

  setMessageBody(state, body){
    state.message_body = body;
  },

  setMessages (state, messages) {
    state.messages = messages;
  },

  setListState (state, list_status) {
    state.list_state = list_status;
  },

  readMessage (state, message) {
    let index = _.findIndex(state.messages, {id: message.id});
    if (index > -1) {
      message.attributes = Object.assign(message.attributes, {unread: false})
      state.messages.splice(index, 1, message);
    } else {
      //обработка ошибок
      console.error('Элемент не найден - ID:', booking.id );
    }

  },

  addMessage (state, message) {
    let i = _.findIndex(state.messages, ['id', message.id]);
    console.log('+++ ADD message', i, message);
    if (i === -1) state.messages.push(message);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
